import uniqBy from "lodash/uniqBy";

(function () {
  // escape hatch
  if (!document.querySelector('[data-stat="live-count"]')) return;

  const database = firebase.database(),
    { envKey, pageID } = WP,
    currentViewersRef = getCurrentViewersRef(database, envKey, pageID),
    viewsRef = database.ref(`${envKey}/event${pageID}/views`);

  // current viewers
  currentViewersRef.on("value", (snapshot) => {
    const data = snapshot.val() || {},
      viewerCount = getViewerCount(data),
      uiTargets = Array.from(
        document.querySelectorAll('[data-stat="live-count"]')
      );

    if (!uiTargets.length) return;

    uiTargets.forEach((uiTarget) => {
      if (viewerCount > 0) {
        uiTarget.innerHTML = `
           ${viewerCount} watching`;
        uiTarget.style.display = "block";
      } else {
        uiTarget.innerHTML = "";
        uiTarget.style.display = "none";
      }
    });
  });

  // total viewers
  viewsRef.on("value", function (snapshot) {
    const data = snapshot.val() || {},
      totalViews = uniqBy(
        Object.values(data).map((user) => ({ id: user.uid || user.anonUid })),
        "id"
      ).length,
      uiTarget = document.querySelector('[data-stat="total-count"]');

    if (uiTarget) uiTarget.innerHTML = ` Total viewers: ${totalViews}`;
  });
})();

/**
 * Check if a timestamp is stale
 * @param {int} - unix timestamp (milliseconds)
 * @returns {bool}
 */
export function isStale(timestamp) {
  // ? no timestamp
  if (!timestamp) return true;
  // ? older than 6 hours
  if (Date.now() - timestamp > 21600000) return true;

  return false;
}

/**
 * Get the currentlyViewing firebase ref
 */
export function getCurrentViewersRef(database, envKey, pageID) {
  return database.ref(`${envKey}/event${pageID}/currentlyViewing`);
}

/**
 * Get the current viewer count from firebase
 */
export function getViewerCount(data) {
  return uniqBy(
    Object.values(data)
      .filter(
        (user) => (!!user.uid || !!user.anonUid) && !isStale(user.timestamp)
      )
      .map((user) => ({ id: user.uid || user.anonUid })),
    "id"
  ).length;
}
